import {Injectable, NgZone} from '@angular/core';
import {UserService} from './user.service';
import {environment} from '../../../environments/environment';

@Injectable()
export class AutoLogoutService {

  constructor(
    private ngZone: NgZone,
    public userService: UserService,
  ) {
    this.lastAction(Date.now());
    this.check();
    this.initListener();
    this.initInterval();
  }

  /**
   * get last action
   */
  getLastAction() {
    return localStorage.getItem('lastAction');
  }

  /**
   * set last action
   * @param value
   */
  lastAction(value) {
    localStorage.setItem('lastAction', JSON.stringify(value));
  }

  /**
   * start event listener
   */
  initListener() {
    this.ngZone.runOutsideAngular(() => {
      document.body.addEventListener('click', () => this.reset());
    });
  }

  /**
   * time interval
   */
  initInterval() {
    this.ngZone.runOutsideAngular(() => {
      setInterval(() => {
        this.check();
      }, 30000); /** check every 30 seconds */
    });
  }

  /**
   * reset timer
   */
  reset() {
    this.lastAction(Date.now());
  }

  /**
   * check timer
   */
  check() {
    const now = Date.now();
    const timeLeft = parseInt(this.getLastAction(), 10) + (environment.autoLogoutInterval * 1000);
    const diff = timeLeft - now;
    const isTimeout = diff < 0;
    this.ngZone.run(() => {
      if (isTimeout && localStorage.getItem('auth.token') !== 'null') {
        localStorage.removeItem('lastAction');
        console.log('Your Session Expired due to Inactivity. Please Login Again');
        this.userService.logout(false);
      }
    });
  }
}
